import { createApp } from "vue";
import "@/styles/app.css";
import App from "@/App.vue";

import { createAppRouter } from "@/router";
import { createPinia } from "pinia";
import i18n from "@/i18n";
import ROUTES from "@/config/ROUTES.ts";
import { createGtag } from "vue-gtag";

const pinia = createPinia();

const router = await createAppRouter(pinia);

const app = createApp(App).use(router).use(pinia).use(i18n);

app.config.globalProperties.$routes = ROUTES;

const gtag = import.meta.env.VITE_APP_GTAG_ID;
if (gtag) {
  app.use(
    createGtag({
      initMode: "manual",
      pageTracker: { router },
      tagId: gtag,
    }),
  );
}

app.mount("#app");
